module.exports = __webpack_public_path__ + "static/media/buyBg.18516341.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/buyBg.png
// module id = 416
// module chunks = 0